const STORAGE = localStorage;

class AppStorage {
  public getBoolean(key: string, defaultValue: boolean): boolean {
    return STORAGE.getItem(key) !== null ? STORAGE.getItem(key) === "true" : defaultValue;
  }

  public getNumber(key: string, defaultValue: number): number {
    return Number(STORAGE.getItem(key) || defaultValue);
  }

  public getString(key: string, defaultValue: string): string {
    return STORAGE.getItem(key) || defaultValue;
  }

  public setBoolean(key: string, value: boolean): void {
    STORAGE.setItem(key, value.toString());
  }

  public setNumber(key: string, value: number): void {
    STORAGE.setItem(key, value.toString());
  }

  public setString(key: string, value: string): void {
    STORAGE.setItem(key, value);
  }

  public getKeys(): string[] {
    return Object.keys(STORAGE);
  }
  public remove(key: string): void {
    STORAGE.removeItem(key);
  }
}

export default new AppStorage();
